import { render, staticRenderFns } from "./tag-dialog-selector.vue?vue&type=template&id=da16e40a&"
import script from "./tag-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./tag-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./tag-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports